import { Button, Form, Input } from 'antd';

import cls from './Comment.module.scss'
import { CommentOutlined } from '@ant-design/icons';
import React from 'react';
import CrmTextModal from '../../../components/Modal/CrmTextModal';
import { useMutation } from '@apollo/client';
import { MUTATION_CREATE_MESSAGE } from '../../../graphql/message';
import { observer } from 'mobx-react-lite';
import { useInstance } from 'react-ioc';
import { Store } from '../../../model/store/Store';

export const CommentSend = observer(({id, onUpdate, child}) => {

    const [open, setOpen] = React.useState(false);
    const {auth} = useInstance(Store)
    const [form] = Form.useForm()

    const [createMessage, {loading}] = useMutation(MUTATION_CREATE_MESSAGE)

    const onFinish = async (data) => {
        await createMessage({
            variables: {
                data: {
                    message: data.message,
                    author: auth.id,
                    client: child ? id : undefined,
                    parent: child? undefined : id,
                }
            },
            onCompleted: () => {
                setOpen(false);
                onUpdate()
                form.resetFields()
            }
        })
    }

    return (
        <div>
            <CrmTextModal isOpen={open} onClose={() => setOpen(false)} title={'Комментарий'}>
                <Form form={form} disabled={loading} size={'large'} layout={'vertical'} onFinish={onFinish}>
                    <Form.Item name={'message'}>
                        <Input.TextArea placeholder={'...'}/>
                    </Form.Item>
                    <Form.Item>
                        <Button loading={loading} htmlType={'submit'} type={'primary'} icon={<CommentOutlined/>}>Оставить</Button>
                    </Form.Item>
                </Form>
            </CrmTextModal>
            <Button type={'link'} icon={<CommentOutlined/>} onClick={() => setOpen(true)}>Оставить</Button>
        </div>
    )
})